import React, { Component } from 'react';

import "./PersonProfile.scss";

class PersonProfile extends Component {
    render() {
        const { color, picture, name, label, horizontal } = this.props
        let classes = ['profile', `profile--${color}`, (horizontal) ? 'profile--horizontal' : ''];
        return (
            <div className={classes.join(' ')}>
                <div className="profile__content">
                    <div className="profile__picture">
                        <div className="profile__picture__photo aspect-ratio-box">
                            <img src={picture} />
                        </div>
                    </div>
                    <div className="profile__text">
                        <h4>{name}</h4>
                        <label>{label}</label>
                    </div>
                </div>
            </div>
        );
    }
}

export { PersonProfile };